import { NavigateBackLink } from '@exam-management/components';
import { useQuestionCreationTaskDetails } from '@exam-management/question-creation-task-details';
import { Flex, PageHeader, Text } from '@shared/components';
import { matchPath, useLocation } from 'react-router-dom';

import { useSingleQuestionDetails } from '../../providers';

export default function SingleQuestionHeader() {
  const { task } = useQuestionCreationTaskDetails();
  const { singleQuestion } = useSingleQuestionDetails();

  const { refCode } = singleQuestion;

  const location = useLocation();
  const matchedTaskManagement = matchPath('/task-management/*', location.pathname);

  return (
    <PageHeader
      title={refCode}
      linkAdornment={
        <NavigateBackLink
          to={
            matchedTaskManagement
              ? '/task-management/question-creation/:taskId/question-list'
              : '/my-task/question-creation/:taskId/question-list'
          }
          replace
          params={{
            taskId: task.id,
          }}
        />
      }
      subtitleSection={
        <Flex
          sx={(theme) => ({
            gap: theme.spacing(2),
          })}
        >
          <Text variant='body2' sx={{ color: (theme) => theme.palette.text.secondary }}>
            Task ID: {task.code}
          </Text>
          <Text variant='body2' sx={{ color: (theme) => theme.palette.text.secondary }}>
            {task.metadata?.requirement.qBankStructure?.name ?? '-'}
          </Text>
        </Flex>
      }
    />
  );
}
